"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function JetSectionTitle(_a) {
    var title = _a.title, description = _a.description;
    return (react_1.default.createElement("div", { className: "md:col-span-1" },
        react_1.default.createElement("div", { className: "px-4 sm:px-0" },
            react_1.default.createElement("h3", { className: "text-lg font-medium text-gray-900" }, title),
            react_1.default.createElement("p", { className: "mt-1 text-sm text-gray-600" }, description))));
}
exports.default = JetSectionTitle;
